import React, { useRef, useLayoutEffect, useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { T } from '../T/index.ts';
import styles from './SegmentedControl.module.scss';
/** Segmented control for switching between a set of options. */ export const SegmentedControl = ({ options, activeId, onTabChange, size, fullWidth = false })=>{
    const containerRef = useRef(null);
    const optionRefs = useRef([]);
    const hasPositionedIndicatorRef = useRef(false);
    const [indicatorStyle, setIndicatorStyle] = React.useState({});
    const stopClickPropagation = (event)=>{
        event.stopPropagation();
    };
    const selectedIndex = useMemo(()=>{
        const index = options.findIndex((option)=>option.id == activeId);
        return index >= 0 ? index : 0;
    }, [
        options,
        activeId
    ]);
    const updateIndicator = useCallback(()=>{
        const activeButton = optionRefs.current[selectedIndex];
        if (activeButton == null) return;
        const isFirstPosition = !hasPositionedIndicatorRef.current;
        hasPositionedIndicatorRef.current = true;
        setIndicatorStyle({
            width: activeButton.offsetWidth,
            transform: `translateX(${activeButton.offsetLeft}px)`,
            transition: isFirstPosition ? 'none' : undefined
        });
    }, [
        selectedIndex
    ]);
    useLayoutEffect(()=>{
        updateIndicator();
        const observer = new ResizeObserver(updateIndicator);
        if (containerRef.current != null) {
            observer.observe(containerRef.current);
        }
        optionRefs.current.forEach((button)=>{
            if (button != null) observer.observe(button);
        });
        return ()=>observer.disconnect();
    }, [
        updateIndicator,
        options
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: clsx(styles.container, styles[size], {
            [styles.fullWidth]: fullWidth
        }),
        onClick: stopClickPropagation
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.indicator,
        style: indicatorStyle
    }), options.map((option, index)=>/*#__PURE__*/ React.createElement("button", {
            key: option.id,
            ref: (el)=>{
                optionRefs.current[index] = el;
            },
            className: styles.option,
            onClick: ()=>onTabChange(option.id),
            type: "button",
            "aria-pressed": index == selectedIndex
        }, /*#__PURE__*/ React.createElement(T, {
            id: option.label
        }))));
};
